var e="undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{};export{e as g};
//# sourceMappingURL=global-b32269a4.js.map
